
const url = 'tigstack';

export const tigStackRoutes = {
  main: `/admin/${url}`,
};
